const Colors = {
    selectedRow: 'var(--accent-row)',    // marka amber'inden türer (bkz. brand.css)
    confirmedRow: 'var(--row-confirmed)' // onaylı rapor / raporu var (bkz. brand.css)
}

export default Colors